import { render } from "./StylePrices.vue?vue&type=template&id=7a351d22&scoped=true"
import script from "./StylePrices.vue?vue&type=script&lang=js"
export * from "./StylePrices.vue?vue&type=script&lang=js"

import "./StylePrices.vue?vue&type=style&index=0&id=7a351d22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a351d22"]])

export default __exports__